let rendererRootNode;
export function setRendererRootNode(node) {
    rendererRootNode = node;
}
export function getRendererRootNode() {
    return rendererRootNode;
}
